import React, { useEffect, useState } from 'react'
import './status-table.styles.scss'

import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { useNavigate } from 'react-router-dom'
import { checkElementAccess } from '@/utils/checkElementAccess'

const PlayerStatusTable = ({
  gameData,
  playerData,
  gameElements,
  playerActivity,
  role
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [itemCount, setItemCount] = useState(0);
  const [currentLevel, setCurrentLevel] = useState(null);
  const [completedChallenges, setCompletedChallenges] = useState([]);
  const [manager, setManager] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!role) return;
    if (role === 'owner' || role === 'manager') {
      setManager(true);
    }
  }, [role])

  useEffect(() => {
    if (!playerData || !gameElements) return;
    if (playerData.levels) {
      const lastLevel = Object.values(playerData.levels).sort((a, b) => a.ts < b.ts ? 1 : -1)[0];
      const level = lastLevel.id;
      setCurrentLevel(level);
    } else {
      const levels = Object.values(gameElements)
        .filter(e => e.type === 'level' && e.status === 'active')
        .sort((a, b) => a.opt_pointMinimum > b.opt_pointMinimum ? 1 : -1)
      for (let l of levels) {
        if (playerData.points >= l.opt_pointMinimum) {
          setCurrentLevel(l.id);
        }
      }
    }
  }, [playerData, gameElements])

  useEffect(() => {
    if (!playerActivity) return;
    const challengeActivity = Object.values(playerActivity).filter(a => a.type === 'approvedChallenge');
    setCompletedChallenges(challengeActivity);
  }, [playerActivity])

  useEffect(() => {
    if (!playerData || !gameElements) return;
    if (playerData.items) {
      let count = Object.values(playerData.items)
        .filter(i =>
          gameElements[i.id] &&
          gameElements[i.id].opt_itemType !== 'prizepack' &&
          gameElements[i.id].opt_itemType !== 'contribution' &&
          gameElements[i.id].opt_itemType !== 'realworld' &&
          gameElements[i.id].opt_visible &&
          gameElements[i.id].status === 'active'
          // &&
          // checkElementAccess(
          //     playerData,
          //     gameElements,
          //     i.id,
          //     null,
          //     null,
          //     'items',
          //     true
          // )
        )
        .reduce((partialSum, a) => partialSum + a.count, 0)
      setItemCount(count);
    }
  }, [playerData, gameElements])

  return (
    <div className={`inhab-status-table ${screenSize}`}>
      {
        (playerData && gameData) &&
        <table className={`g-table no-header ${screenSize}`}>
          <tbody>
            {/* XP */}
            {
              (gameData.access.includes('points')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/xp.png' alt='xp icon' className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      XP
                    </td>
                    :
                    <td>
                      <span className='status-text'>XP:</span>
                    </td>
                }
                <td>
                  <span className='data-text'>{playerData.points ? playerData.points.toLocaleString() : '0'}</span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('xp')}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} title='View all earnings' />
                  </button>
                </td>
              </tr>
            }
            {/* BADGES */}
            {
              (gameData.access.includes('badges')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/icons/badges.png' alt='badges icon' className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      Badges
                    </td>
                    :
                    <td>
                      <span className='status-text'>Badges:</span>
                    </td>

                }
                <td>
                  <span className='data-text'>
                    {playerData.badges ? Object.values(playerData.badges).length : '0'}
                    <span className='data-meta'> of {gameData.createdBadges ? gameData.createdBadges : '0'}</span>
                  </span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('badges')}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} title='View my badges' />
                  </button>
                </td>
              </tr>
            }
            {/* LEVELS */}
            {
              (gameData.access.includes('levels') && gameElements) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src={
                    // (currentLevel && gameElements[currentLevel])
                    // ?
                    // gameElements[currentLevel].icon
                    // :
                    // `/images/unknown.png`
                    '/images/icons/levels3.png'
                  }
                    alt='my level icon'
                    className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      Level
                    </td>
                    :
                    <td className=''>
                      <span className='status-text'>Level:</span>
                    </td>
                }
                <td>
                  <span className='data-text'>
                    {
                      (currentLevel && gameElements[currentLevel])
                        ?
                        <div className='level-td'>
                          <ImageContainer
                            src={
                              (currentLevel && gameElements[currentLevel])
                                ? gameElements[currentLevel].icon
                                : '/images/unknown.png'
                            }
                            className={'status-icon'} />
                          {gameElements[currentLevel].name}
                        </div>
                        :
                        `No level yet...`
                    }
                  </span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('levels')}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      title='View all levels'
                    />
                  </button>
                </td>
              </tr>
            }
            {/* CURRENT BALANCE */}
            {
              (gameData.access.includes('currency')) &&
              <>
                <tr>
                  <td className='icon-td'>
                    <ImageContainer src='/images/icons/coins.png' alt='currency icon' className='status-icon' />
                  </td>
                  {
                    (screenSize === 'mobile')
                      ?
                      <td className='meta'>
                        Currency
                      </td>
                      :
                      <td>
                        <span className='status-text'>Current Balance:</span>
                      </td>
                  }
                  <td>
                    <span className='data-text'>
                      <div className='currency-cell'>
                        <ImageContainer src='/images/icons/coin.png' alt='coin icon' className='currency-icon' />
                        {
                          (playerData.currency)
                            ?
                            playerData.currency.toLocaleString()
                            :
                            0
                        }
                      </div>
                    </span>
                  </td>
                  <td className='shrink-cell'>
                    <button
                      className='g-button med-btn'
                      onClick={() => navigate('currency')}
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        title='View my earnings'
                      />
                    </button>
                  </td>
                </tr>
                {/* TOTAL CURRENCY EARNED */}
                <tr>
                  <td className='icon-td'>
                    <ImageContainer src='/images/icons/bank.png' alt='total currency icon' className='status-icon' />
                  </td>
                  {
                    (screenSize === 'mobile')
                      ?
                      <td className='meta'>
                        Earnings
                      </td>
                      :
                      <td>
                        <span className='status-text'>Total Earnings:</span>
                      </td>
                  }
                  <td>
                    <span className='data-text'>
                      <div className='currency-cell'>
                        <ImageContainer src='/images/icons/coin.png' alt='coin icon' className='currency-icon' />
                        {
                          (playerData.currencyTotal)
                            ?
                            playerData.currencyTotal.toLocaleString()
                            :
                            0
                        }
                      </div>
                    </span>
                  </td>
                  <td className='shrink-cell'>
                    <button
                      className='g-button med-btn'
                      onClick={() => navigate('currencytotal')}
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        title='View my earnings'
                      />
                    </button>
                  </td>
                </tr>
              </>
            }
            {/* ITEMS */}
            {
              (gameData.access.includes('items')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/icons/backpack.png' alt='items icon' className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      Items
                    </td>
                    :
                    <td>
                      <span className='status-text'>Item Count:</span>
                    </td>
                }
                <td>
                  <span className='data-text'>
                    {itemCount}
                  </span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('inventory')}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} title='View my items' />
                  </button>
                </td>
              </tr>
            }
            {/* SECRET CODES */}
            {
              (gameData.access.includes('secretCodes')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/icons/secret.png' alt='secret codes icon' className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      Codes
                    </td>
                    :
                    <td>
                      <span className='status-text'>Secret Codes:</span>
                    </td>
                }
                <td>
                  <span className='data-text'>
                    {
                      playerData.secretCodes
                        ? Object.keys(playerData.secretCodes).length
                        : '0'
                    }
                  </span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('secretcodes')}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      title='View my codes'
                    />
                  </button>
                </td>
              </tr>
            }
            {/* CHALLENGES */}
            {
              (gameData.access.includes('challenges')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/icons/win.png' alt='challenges icon' className='status-icon' />
                </td>
                {
                  (screenSize === 'mobile')
                    ?
                    <td className='meta'>
                      Challenges
                    </td>
                    :
                    <td>
                      <span className='status-text'>Completed Challenges:</span>
                    </td>
                }
                <td>
                  <span className='data-text'>
                    {completedChallenges.length}
                    <span className='data-meta'> of {gameData.createdChallenges ? gameData.createdChallenges : '0'}</span>
                  </span>
                </td>
                <td className='shrink-cell'>
                  <button
                    className='g-button med-btn'
                    onClick={() => navigate('completedchallenges')}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      title='View my challenges'
                    />
                  </button>
                </td>
              </tr>
            }
            {/* QUESTS */}
            {
              (gameData.access.includes('quests')) &&
              <tr>
                <td className='icon-td'>
                  <ImageContainer src='/images/icons/sidequest.png' alt='quests icon' className='status-icon' />
                </td>
                <td>
                  <span className='status-text'>Completed Quests:</span>
                </td>
                <td>
                  <span className='data-text'>

                  </span>
                </td>
                <td className='shrink-cell'>
                  <button className='g-button med-btn disabled'>View Quests</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      <div className='g-space-0-5'></div>
    </div>
  )
}

export default PlayerStatusTable